import { render, staticRenderFns } from "./CustomerOutstandingInfo.vue?vue&type=template&id=53821319"
import script from "./CustomerOutstandingInfo.vue?vue&type=script&lang=js"
export * from "./CustomerOutstandingInfo.vue?vue&type=script&lang=js"
import style0 from "./CustomerOutstandingInfo.vue?vue&type=style&index=0&id=53821319&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports